import CryptoJS from 'crypto-js';

const algorithm = "aes-256-ctr";
const secretKey = "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3";
const iv = CryptoJS.lib.WordArray.random(128/8);

export const encrypt = (text) => {
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey, { iv: iv });
  return {
    iv: iv.toString(),
    content: ciphertext.toString()
  };
};

export const decrypt = (hash) => {
  const iv = CryptoJS.enc.Hex.parse(hash.iv);
  const ciphertext = CryptoJS.enc.Hex.parse(hash.content);
  const plaintext = CryptoJS.AES.decrypt(ciphertext, secretKey, { iv });
  return plaintext.toString(CryptoJS.enc.Utf8);
};
